module.exports = __webpack_public_path__ + "img/institut_philippe_pinel.83fa741a.webp";